export default {
    url: '/add/:planningGroupId?',
    params: {
        planningGroupId: { squash: true, value: null }
    },
    template: `
    <div class="heading02">
        <div class="heading01">
            <h2>{{ 'planningGroup.Add group' | translate }}</h2>
        </div>
        <div class="arrow-steps clearfix">
            <div class="step" ng-class="{ current: vm.step==1 }">
                <span ng-if="vm.step==1">{{ 'course.General data' | translate }}</span>
                <a ng-if="vm.step>1"
                    ui-sref="authorized.courses.courses.edit.occurrence.automated.add.general({ id: vm.course.id, planningGroupId: vm.planningGroup.id })"
                >{{ 'planningGroup.General data' | translate }}</a>
            </div>
            <div class="step" ng-class="{ current: vm.step==2 }">
                <span ng-if="vm.step<=2">{{ 'course.Targets' | translate }}</span>
                <a ng-if="vm.step>2"
                    ui-sref="authorized.courses.courses.edit.occurrence.automated.add.targets({ id: vm.course.id, planningGroupId: vm.planningGroup.id })"
                >{{ 'planningGroup.Targets' | translate }}</a>
            </div>
            <div class="step" ng-class="{ current: vm.step==3 }">
                <span ng-if="vm.step<=3">{{ 'course.Employees' | translate }}</span>
                <a ng-if="vm.step>3"
                    ui-sref="authorized.courses.courses.edit.occurrence.automated.add.employee({ id: vm.course.id, planningGroupId: vm.planningGroup.id })"
                >{{ 'planningGroup.Employees' | translate }}</a>
            </div>
        </div>
    </div>
    <div class="content01">
        <ui-view></ui-view>
    </div>
    `,
    abstract: true,
    resolve: {
        planningGroup ($stateParams, AutomatedPlanningGroupResource) {
            if ($stateParams.planningGroupId) {
                const expand = [
                    'planningGroupUsers',
                    'course',
                    'planningGroupTargetsWithValue.user.drlsWithValue',
                    'planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue',
                    'targetRulesets.conditions'
                ].join(',');
                return AutomatedPlanningGroupResource.get({
                    id: $stateParams.planningGroupId,
                    expand
                }).$promise;
            }
            return new AutomatedPlanningGroupResource({ courseId: $stateParams.id, planningGroupUsers: [] });
        }
    },
    controller ($scope, planningGroup, course, AUTOMATED_PLANNING_GROUP_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM) {
        this.$scope = $scope;
        this.course = course;
        if (!planningGroup.id) {
            planningGroup.status = AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.NOT_STARTED;
            planningGroup.type = AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.MANUAL;
        }
        this.planningGroup = planningGroup;
        this.$scope.$on('planning-group:update', (event, updatedGroup) => {
            this.planningGroup = updatedGroup;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/automated/add/index.js